module.exports = __webpack_public_path__ + "static/img/021_7.155ac66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/021_7.jpg
// module id = CrRP
// module chunks = 1